/**
 * Encode emergency actions for Gnosis Safe
 */
import type { Address } from "viem"
import { encodeFunctionData } from "viem"
import { breakoutMarketAbi } from "../../abi/generated/breakoutMarket"
import type { SafeTransaction } from "../../types"

export interface EncodeEmergencyPauseParams {
	market: Address
}

/**
 * Encode an emergency pause transaction for Gnosis Safe
 */
export function encodeEmergencyPause(params: EncodeEmergencyPauseParams): SafeTransaction {
	const data = encodeFunctionData({
		abi: breakoutMarketAbi,
		functionName: "emergencyPause",
		args: [],
	})

	return {
		to: params.market,
		value: "0",
		data,
	}
}

export interface EncodeEmergencyUnpauseParams {
	market: Address
}

/**
 * Encode an emergency unpause transaction for Gnosis Safe
 */
export function encodeEmergencyUnpause(params: EncodeEmergencyUnpauseParams): SafeTransaction {
	const data = encodeFunctionData({
		abi: breakoutMarketAbi,
		functionName: "emergencyUnpause",
		args: [],
	})

	return {
		to: params.market,
		value: "0",
		data,
	}
}

export interface EncodeEmergencySweepParams {
	market: Address
	to: Address
}

/**
 * Encode an emergency sweep transaction for Gnosis Safe
 *
 * Can only be called when the market is paused.
 * Sweeps all funds to the specified address for off-chain refunds.
 */
export function encodeEmergencySweep(params: EncodeEmergencySweepParams): SafeTransaction {
	const data = encodeFunctionData({
		abi: breakoutMarketAbi,
		functionName: "emergencySweep",
		args: [params.to],
	})

	return {
		to: params.market,
		value: "0",
		data,
	}
}
